/**
 * Cart Select - Partial Checkout Implementation
 * Updated for Shopify default checkout (non-Swift Checkout)
 * Using event delegation pattern for persistent event listeners
 */

document.addEventListener('DOMContentLoaded', function () {
    const productCheckbox = '.cart-item__select';

    function updateSelectedCount() {
        const selectedCount = document.querySelectorAll('.cart-item__select:checked').length;
        const selectedCountLabel = document.getElementById('selected-count');
        const checkoutButton = document.querySelector('.cart__checkout-button, button[name="checkout"]');

        if (selectedCount > 0) {
            selectedCountLabel.textContent = selectedCount;
            if (checkoutButton) {
                checkoutButton.removeAttribute('disabled');
                checkoutButton.removeAttribute('aria-disabled');
                checkoutButton.style.opacity = '1';
            }
        } else {
            selectedCountLabel.textContent = '0';
            if (checkoutButton) {
                checkoutButton.setAttribute('disabled', 'true');
                checkoutButton.setAttribute('aria-disabled', 'true');
                checkoutButton.style.opacity = '0.5';
            }
        }
        updateCalculationSummary();
    }

    /**
     * Handle checkout with only selected items
     * Save unchecked items to localStorage, remove from cart, then restore on return
     */
    function handlePartialCheckout(event) {
        event.preventDefault();
        console.log('[Cart Select] Checkout button clicked');

        const allCheckboxes = document.querySelectorAll('.cart-item__select');
        const uncheckedItems = Array.from(allCheckboxes).filter(cb => !cb.checked && !cb.disabled);

        console.log('[Cart Select] Total items:', allCheckboxes.length);
        console.log('[Cart Select] Unchecked items:', uncheckedItems.length);

        if (uncheckedItems.length === 0) {
            // All items selected, proceed to checkout normally
            console.log('[Cart Select] All items selected, proceeding to checkout');
            // Clear any saved items
            localStorage.removeItem('casio_saved_cart_items');
            window.location.href = '/checkout';
            return;
        }

        // Show loading state
        const checkoutButton = event.target;
        const originalText = checkoutButton.textContent;
        checkoutButton.textContent = 'Processing...';
        checkoutButton.disabled = true;

        // Save unchecked items data to localStorage before removing
        const savedItems = uncheckedItems.map(checkbox => {
            const row = checkbox.closest('.cart-item-card');
            const quantityInput = row.querySelector('input[type="number"][name="updates[]"]');

            return {
                key: checkbox.getAttribute('data-key'),
                variantId: checkbox.getAttribute('data-variant-id'),
                quantity: quantityInput ? parseInt(quantityInput.value) : 1
            };
        });

        localStorage.setItem('casio_saved_cart_items', JSON.stringify(savedItems));
        console.log('[Cart Select] Saved items to localStorage:', savedItems);

        // Remove unchecked items by setting their quantity to 0
        const removePromises = uncheckedItems.map(checkbox => {
            const key = checkbox.getAttribute('data-key');
            console.log('[Cart Select] Removing item with key:', key);

            return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: key,
                    quantity: 0
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('[Cart Select] Item removed:', key);
                return data;
            })
            .catch(error => {
                console.error('[Cart Select] Error removing item:', key, error);
                throw error;
            });
        });

        // Wait for all items to be removed, then redirect to checkout
        Promise.all(removePromises)
            .then(() => {
                console.log('[Cart Select] All unchecked items removed, redirecting to checkout');
                window.location.href = '/checkout';
            })
            .catch(error => {
                console.error('[Cart Select] Error during partial checkout:', error);
                alert('An error occurred. Please try again.');
                checkoutButton.textContent = originalText;
                checkoutButton.disabled = false;
            });
    }

    /**
     * Show loading overlay on cart page
     */
    function showCartLoader() {
        // Create loading overlay if it doesn't exist
        let loader = document.getElementById('cart-restore-loader');

        if (!loader) {
            loader = document.createElement('div');
            loader.id = 'cart-restore-loader';
            loader.style.cssText = `
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 9999;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 1rem;
            `;

            loader.innerHTML = `
                <div class="loading-overlay__spinner" style="position: relative; width: 4rem; height: 4rem;">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 4rem; height: 4rem; color: #003296;">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
                <p style="font-size: 1.4rem; color: #000; margin: 0; font-weight: 500;">Restoring cart items...</p>
            `;

            document.body.appendChild(loader);
        }

        loader.style.display = 'flex';
    }

    /**
     * Hide loading overlay
     */
    function hideCartLoader() {
        const loader = document.getElementById('cart-restore-loader');
        if (loader) {
            loader.style.display = 'none';
        }
    }

    /**
     * Restore saved cart items when user returns from checkout
     */
    function restoreSavedCartItems() {
        const savedItemsJson = localStorage.getItem('casio_saved_cart_items');

        if (!savedItemsJson) {
            console.log('[Cart Select] No saved items to restore');
            return;
        }

        console.log('[Cart Select] Found saved items, restoring...');
        const savedItems = JSON.parse(savedItemsJson);

        // Show loading overlay
        showCartLoader();

        // Add saved items back to cart
        const restorePromises = savedItems.map(item => {
            console.log('[Cart Select] Restoring item:', item.variantId, 'qty:', item.quantity);

            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: item.variantId,
                    quantity: item.quantity
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('[Cart Select] Item restored:', item.variantId);
                return data;
            })
            .catch(error => {
                console.error('[Cart Select] Error restoring item:', item.variantId, error);
                // Don't throw, continue with other items
                return null;
            });
        });

        Promise.all(restorePromises)
            .then(() => {
                console.log('[Cart Select] All items restored');
                // Clear saved items from localStorage
                localStorage.removeItem('casio_saved_cart_items');

                // Reload page to show restored items
                // This is more reliable than fetching and replacing DOM
                // because Shopify needs time to fully update cart state on server
                window.location.reload();
            })
            .catch(error => {
                console.error('[Cart Select] Error during restore:', error);
                // Hide loading overlay
                hideCartLoader();
                // Reload anyway to show whatever items were successfully added
                window.location.reload();
            });
    }

    function updateCalculationSummary() {
        let totalPrice = 0;

        const checkedBoxes = document.querySelectorAll('.cart-item__select:checked');
        console.log('[Cart Select] updateCalculationSummary called, checked items:', checkedBoxes.length);

        checkedBoxes.forEach((checkbox) => {
            const row = checkbox.closest('.cart-item-card');
            console.log('[Cart Select] Row found:', !!row);

            if (!row) {
                console.error('[Cart Select] Cannot find .cart-item-card parent');
                return;
            }

            // Debug: log all price elements
            const allPrices = row.querySelectorAll('.cart-item__totals .price');
            console.log('[Cart Select] Found', allPrices.length, 'price elements in totals');
            allPrices.forEach((p, i) => {
                console.log(`  Price ${i + 1}:`, p.className, '→', p.textContent.trim().substring(0, 30));
            });

            // Try to get sale price first (dd.price.price_sale), otherwise regular price (span.price)
            // Must exclude .cart-item__old-price (strikethrough)
            let priceElement = row.querySelector('.cart-item__totals dd.price.price_sale');
            console.log('[Cart Select] Sale price (dd.price_sale):', !!priceElement);

            if (!priceElement) {
                priceElement = row.querySelector('.cart-item__totals span.price:not(.cart-item__old-price)');
                console.log('[Cart Select] Regular price (span.price):', !!priceElement);
            }

            if (!priceElement) {
                console.error('[Cart Select] Cannot find valid price element!');
                return;
            }

            let priceText = priceElement.textContent || '';
            // Clean whitespace and newlines
            priceText = priceText.trim().replace(/\s+/g, ' ');

            // Extract only digits
            const priceDigits = priceText.replace(/[^\d]/g, '');
            const price = parseFloat(priceDigits) || 0;

            console.log('[Cart Select] Selected price text:', JSON.stringify(priceText), '→ Digits:', priceDigits, '→ Parsed:', price);
            totalPrice += price;
        });

        console.log('[Cart Select] Total:', totalPrice);

        // Format as Indonesian Rupiah
        const formattedPrice = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(totalPrice);

        const priceSummary = document.querySelector('.totals__subtotal-value');

        if (priceSummary) {
            priceSummary.textContent = formattedPrice;
        }
    }

    /**
     * Use event delegation with 'change' event (proper way for checkboxes)
     * Change event is more reliable for checkboxes than click
     * Using capture phase (true) to catch events even if stopPropagation is called
     */
    console.log('[Cart Select] Attaching change event listener with capture...');
    document.addEventListener('change', function(event) {
        console.log('[Cart Select] Change event detected on:', event.target);

        if (event.target && event.target.matches(productCheckbox)) {
            console.log('[Cart Select] Checkbox changed! New checked state:', event.target.checked);
            updateSelectedCount();
        }
    }, true); // true = use capture phase

    // Initialize on load
    console.log('[Cart Select] Initializing...');

    // Check if we need to restore saved items (user returned from checkout)
    restoreSavedCartItems();

    // Debug: Check if checkboxes exist
    const allCheckboxes = document.querySelectorAll('.cart-item__select');
    console.log('[Cart Select] Found checkboxes on load:', allCheckboxes.length);
    allCheckboxes.forEach((cb, i) => {
        console.log(`  Checkbox ${i + 1}:`, cb.id, 'Checked:', cb.checked);
    });

    // Attach checkout button event listener
    const checkoutButton = document.querySelector('.cart__checkout-button, button[name="checkout"]');
    if (checkoutButton) {
        console.log('[Cart Select] Attaching checkout button click listener');
        checkoutButton.addEventListener('click', handlePartialCheckout);
    }

    updateSelectedCount();
});
